// extracted by mini-css-extract-plugin
export var button = "_1m-0";
export var buttonContent = "_1m-e";
export var buttonGroup = "_1m-c";
export var dontRestrainIconWidth = "_1m-a";
export var dropdownButton = "_1m-b";
export var iconContainer = "_1m-9";
export var lg = "_1m-4";
export var md = "_1m-3";
export var pending = "_1m-f";
export var sm = "_1m-2";
export var spinner = "_1m-d";
export var squared = "_1m-8";
export var wrapText = "_1m-g";
export var xl = "_1m-5";
export var xs = "_1m-1";
export var xxl = "_1m-6";
export var xxxl = "_1m-7";